import React, { Component } from 'react';
import Select from '../../../shared/select';

class TrainerInput extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  static defaultProps = {
    id: 'trainer',
  };

  handleChange(e) {
    this.props.onChange(e.target.value, this.props.id);
  }

  render() {
    return (
      <div className="EventSessionForm-field">
        <label htmlFor={this.props.id}>{t('common.instructor')}</label>
        <Select
          ariaLabel={t('common.instructor')}
          onChange={this.handleChange}
          value={this.props.value}
          id={this.props.id}
          fullWidth
        >
          <option value="">{t('users.select')}</option>
          {this.props.users.map(user => (
            <option key={user.id} value={user.id}>
              {user.name}
            </option>
          ))}
        </Select>
      </div>
    );
  }
}

export default TrainerInput;
